import React, { useState, useEffect } from 'react';
import queryString from 'query-string';
import { baseUrl } from '../../../config/baseUrl';
import { getDecodedData } from "../../../helpers";
import './hosted-failure.css';

function CsHostedFailure() {
  const [errorMessage, setErrorMessage] = useState('The payment could not be processed.');
  const [retryUrl, setRetryUrl] = useState('');
  const [cancelUrl, setCancelUrl] = useState('');

  useEffect(() => {
    const { query } = queryString.parseUrl(window.location.href);
    const { data, response, message } = query;

    message && setErrorMessage(message);

    const decryptData = async (response) => {
      const { decodedString } = await getDecodedData(response);
      setCancelUrl(decodedString?.cancel_url);
    };
    response && decryptData(response);

    // Build retry URL — re-initiates the hosted form flow with the same data
    if (data) {
      setRetryUrl(`${window.location.origin}/sale?${queryString.stringify({ data, response })}`);
    }
  }, []);

  const handleRetry = () => {
    if (retryUrl) window.location.href = retryUrl;
  };

  const handleCancel = () => {
    window.location.href = cancelUrl;
  };

  return (
    <div className="cs-failure-wrapper">
      <div className="cs-failure-card">
        <div className="cs-failure-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
        </div>

        <h1 className="cs-failure-title">Payment failed</h1>
        <p className="cs-failure-subtitle">
          If an amount was debited, it will be refunded to your card within 3 to 5 working days.
        </p>

        <div className="cs-failure-reason">
          <span className="cs-failure-reason-label">Reason</span>
          <p className="cs-failure-reason-text">{errorMessage}</p>
        </div>

        <div className="cs-failure-actions">
          <button
            type="button"
            className="cs-btn cs-btn-primary"
            onClick={handleRetry}
            disabled={!retryUrl}
          >
            Retry payment
          </button>
          <button
            type="button"
            className="cs-btn cs-btn-secondary"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>

        <p className="cs-failure-help">
          If the problem persists, please contact support.
        </p>
      </div>
    </div>
  );
}

export default CsHostedFailure;
